/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    findAddress,
    getAddress,
    fetchMuseums,
    fetchStorageLocations,
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import AddressLookup from '../../../components/common/Address/AddressLookup'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        address: state.address,
        setAddress: props.setAddress,
    }
}

export default connect(mapStateToProps, {
    findAddressTrigger: findAddress,
    getAddressTrigger: getAddress,
    fetchMuseums,
    fetchStorageLocations,
} )(AddressLookup)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/common/Address/Address.tsx